/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import PeriodEntry, { displayStringFromFHIRPeriod } from "./PeriodEntry";
import StringEntry from "./StringEntry";
import ArrayEntry from "./ArrayEntry";
import CodeEntry from "./CodeEntry";
import PositiveIntEntry from "./PositiveIntEntry";
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";

const ContactPointDisplay = ({ contactPoint }) => {
  if (contactPoint) {
    if (Array.isArray(contactPoint) || typeof contactPoint !== "object") {
      return <>[ERROR: ContactPoint data not interpretable.]</>;
    }
    return <div style={{ marginLeft: "24px" }}>
      {contactPoint.system && <p><b>Contact Type: </b>{contactPoint.system} </p>}
      {contactPoint.value && <p><b>Detail: </b>{contactPoint.value} </p>}
      {contactPoint.use && <p><b>Use: </b>{contactPoint.use} </p>}
      {contactPoint.period && <p><b>Period: </b>{displayStringFromFHIRPeriod(contactPoint.period)} </p>}
    </div>
  } else {
    return <></>
  }
}

const DisplayFromFHIRContactDetail = ({ contactDetail }) => {
  if (contactDetail) {
    if (Array.isArray(contactDetail) || typeof contactDetail !== "object") {
      return <>[ERROR: ContactDetail data not interpretable.]</>;
    }
    let nameDisplay = contactDetail.name || "[No name provided.]";
    return <div>
      <p><b>Name: </b>{nameDisplay}</p>
      {Array.isArray(contactDetail.telecom) && contactDetail.telecom.map((telecom, telecomIndex) => {
        return <div key={telecomIndex}><p><b>Contact Method: </b></p><ContactPointDisplay contactPoint={telecom} /><br /></div>
      })}
      {(contactDetail.telecom && !Array.isArray(contactDetail.telecom)) && <>[ERROR: contactDetail.telecom is not in expected JSON form (should be an array).]</>}
    </div>
  } else {
    return <></>
  }
}

const ContactDetailEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed }) => {

  const [contactDetailState, setContactDetailState] = useState({});
  const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

  useEffect(() => {
    let startingContactDetail = { "name": "", "telecom": [] };
    if (startingValue) {
      if (startingValue.extension) { startingContactDetail.extension = startingValue.extension; }
      if (startingValue.name) { startingContactDetail.name = startingValue.name; }
      if (startingValue.telecom) { startingContactDetail.telecom = startingValue.telecom; }
    }
    setContactDetailState(JSON.parse(JSON.stringify(startingContactDetail)));
  }, []);

  useEffect((() => {
    if (Object.keys(contactDetailState).length) {
      let newContactDetail = {};
      if (contactDetailState.extension) { newContactDetail.extension = contactDetailState.extension; }
      if (contactDetailState.name) { newContactDetail.name = contactDetailState.name; }
      if (contactDetailState.telecom !== null && contactDetailState.telecom !== undefined &&
        Array.isArray(contactDetailState.telecom) && contactDetailState.telecom.length !== 0 &&
        !(contactDetailState.telecom.length === 1 && Object.keys(contactDetailState.telecom[0]).length === 0)) {
        newContactDetail.telecom = contactDetailState.telecom;
      }
      if (Object.keys(newContactDetail).length === 0) {
        newContactDetail = null;
      }
      setResourceState(prevState => { return { ...prevState, [elementName]: newContactDetail } });
    }
  }), [contactDetailState]);

  if (startCollapsedState) {
    return <>
      <div>
        <b>{fieldLabel}: </b>
        {startingValue && <DisplayFromFHIRContactDetail contactDetail={startingValue} />}
        &nbsp;&nbsp;
        <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
      </div>
    </>
  } else if (Object.keys(contactDetailState).length > 0) {
    return <div>
      <p style={{ marginBottom: "2px" }}><b>{fieldLabel}: </b></p>
      <div style={{ marginLeft: "24px" }}>
        <StringEntry elementName='name' fieldLabel='Name'
          startingValue={contactDetailState.name} setResourceState={setContactDetailState} />
        <ArrayEntry datatype='ContactPoint' elementName='telecom' startCollapsed={true}
          startEmptyArrayClosed={true}
          fieldLabel='Contact Point' startingValue={contactDetailState.telecom} setResourceState={setContactDetailState} />
      </div>
    </div>
  }
}

const contactPointDotSystemValues = ['phone', 'fax', 'email', 'pager', 'url', 'sms', 'other'];
const contactPointDotUseValues = ['home', 'work', 'temp', 'old', 'mobile'];
const ContactPointEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed }) => {

  const [contactPointState, setContactPointState] = useState({});
  const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

  useEffect(() => {
    let startingContactPoint = { "system": "", "value": "", "use": "", "rank": "", "period": "" };
    if (startingValue) {
      if (startingValue.extension) { startingContactPoint.extension = startingValue.extension; }
      if (startingValue.system) { startingContactPoint.system = startingValue.system; }
      if (startingValue.value) { startingContactPoint.value = startingValue.value; }
      if (startingValue.use) { startingContactPoint.use = startingValue.use; }
      if (startingValue.rank) { startingContactPoint.rank = startingValue.rank; }
      if (startingValue.period) { startingContactPoint.period = startingValue.period; }
    }
    setContactPointState(JSON.parse(JSON.stringify(startingContactPoint)));
  }, []);

  useEffect((() => {
    if (Object.keys(contactPointState).length) {
      let newContactPoint = {};
      if (contactPointState.extension) { newContactPoint.extension = contactPointState.extension; }
      if (contactPointState.system) { newContactPoint.system = contactPointState.system; }
      if (contactPointState.value) { newContactPoint.value = contactPointState.value; }
      if (contactPointState.use) { newContactPoint.use = contactPointState.use; }
      if (contactPointState.rank) { newContactPoint.rank = contactPointState.rank; }
      if (contactPointState.period && Object.keys(contactPointState.period).length) { newContactPoint.period = contactPointState.period; }
      if (Object.keys(newContactPoint).length === 0) {
        newContactPoint = null;
      }
      setResourceState(prevState => { return { ...prevState, [elementName]: newContactPoint } });
    }
  }), [contactPointState]);

  if (startCollapsedState) {
    return <>
      <div>
        <b>{fieldLabel}: </b>
        {startingValue && <ContactPointDisplay contactPoint={startingValue} />}
        &nbsp;&nbsp;
        <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
      </div>
    </>
  } else if (Object.keys(contactPointState).length > 0) {
    return <div>
      <p style={{ marginBottom: "2px" }}><b>{fieldLabel}: </b></p>
      <div style={{ marginLeft: "24px" }}>
        <CodeEntry elementName='system' fieldLabel='Contact Type'
          allowedValues={contactPointDotSystemValues}
          startingValue={contactPointState.system} setResourceState={setContactPointState} />
        <StringEntry elementName='value' fieldLabel='Value'
          startingValue={contactPointState.value} setResourceState={setContactPointState} />
        <CodeEntry elementName='use' fieldLabel='Use'
          allowedValues={contactPointDotUseValues}
          startingValue={contactPointState.use} setResourceState={setContactPointState} />
        <PositiveIntEntry elementName='rank' fieldLabel='Rank'
          startingValue={contactPointState.rank} setResourceState={setContactPointState} />
        <br /><br />
        <PeriodEntry elementName='period' fieldLabel='Period' startCollapsed={true}
          startingValue={contactPointState.period} setResourceState={setContactPointState} />
      </div>
    </div>
  }
}

export default ContactDetailEntry;
export { ContactPointEntry, DisplayFromFHIRContactDetail };